import { m } from 'motion/react';
import type React from 'react';

type AnimateMessageProps = { children: React.ReactNode };

export function AnimateMessage({ children }: AnimateMessageProps) {
  return (
    <m.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.15 }}>
      {children}
    </m.div>
  );
}
